export default {
  "content": "<path d=\"M0 0h32v32H0z\" fill=\"none\"/><g fill=\"#3F4450\"><path d=\"M30.605 13.2l.005-.007-2.591-1.9V8a1 1 0 00-1-1h-22a1 1 0 00-1 1v3.271l-2.628 1.922.005.007a.991.991 0 00-.415.8v16a1 1 0 001 1h28.038a1 1 0 001-1V14a.994.994 0 00-.414-.8zm-2.419.696l-.167.095v-.218zM26.019 9v6.134l-10 5.715-10-5.698V9zm-22 5.01l-.201-.115.201-.147zm25 14.99H2.981V15.721l12.542 7.148a.998.998 0 00.991 0l12.504-7.145V29zm-14-29h2v4h-2zM22.187 1.445l1.664 1.11-2 3-1.664-1.11zM9.85 1.446l2 3-1.663 1.11-2-3z\"/></g>",
  "attrs": {
    "viewBox": "0 0 32 32",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};